import React from 'react';
import { cn } from '@/lib/utils';
import { MerchantStatusId, getMerchantStatus } from '@/shared/merchantStatus';

// Dot-plus-label badge (REQ-009). Colour never carries meaning alone: the label
// is always shown, and Test uses a dashed outline to read as "not real".

interface MerchantStatusBadgeProps {
  status: MerchantStatusId;
  className?: string;
}

export const MerchantStatusBadge: React.FC<MerchantStatusBadgeProps> = ({ status, className }) => {
  const definition = getMerchantStatus(status);
  return (
    <span
      data-testid={`merchant-status-${status}`}
      className={cn(
        'inline-flex h-[22px] items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 text-xs font-semibold',
        definition.badgeClassName,
        className,
      )}
    >
      <span aria-hidden="true" className={cn('h-[7px] w-[7px] flex-none rounded-full', definition.dotClassName)} />
      {definition.label}
    </span>
  );
};

export default MerchantStatusBadge;
